<script setup lang="ts">
const { t } = useI18n();
const route = useRoute();

async function openLogin() {
  await navigateTo(
    { query: { ...route.query, modal: "login" } },
    { replace: true }
  );
}

const accountTypeOptions = ref([
  t("form.register.private"),
  t("form.register.business"),
]);
const accountType = ref(t("form.register.private"));
</script>

<template>
  <Card
    :pt="{
      body: 'grid gap-y-10',
      content: 'space-y-6',
    }"
  >
    <template #subtitle>
      <section class="flex flex-col items-center gap-2">
        <p>{{ $t("form.chooseAccountType") }}</p>

        <SelectButton
          v-model="accountType"
          :options="accountTypeOptions"
          aria-labelledby="account type"
        />

        <div>
          {{ $t("form.alreadyHaveAnAccount") }}
          <button
            class="underline uppercase hover:no-underline"
            @click="openLogin"
          >
            {{ $t("form.logIn") }}
          </button>
        </div>
      </section> </template
    >>

    <template #content>
      <Transition
        mode="out-in"
        enter-from-class="-translate-x-1/2 opacity-0"
        leave-to-class="translate-x-full opacity-0"
        enter-active-class="transition-all duration-400"
        leave-active-class="transition-all duration-300"
      >
        <AccountRegisterForm
          v-if="accountType === t('form.register.private')"
        />
        <AccountRegisterBusinessForm
          v-else-if="accountType === t('form.register.business')"
        />
      </Transition>
    </template>
  </Card>
</template>
